import React from 'react';
import { get, post, put, del, patch } from '../../Utility/Http';
import { hotel_list_get, userDetailsGet, hotelStatusUpdateApi, adminCreatePost, adminCreatePatch, hotelCreatePost, hotelPatchApi, hotelsDeleteApi, subscriptionListGet, subscribApiCallFn, versionListGet, paymentCreatePost, paymentCreatePatch, uploadScreenshotPost, creditPointGet, paymentPriceDistributionGet } from '../Model/OrganizationModel';

export const hotelList = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}org`, data);
    return hotel_list_get(response);
};

export const user_Details = async (id, data) => {
    const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}admin/${id}`, data);
    return userDetailsGet(response);
};

export const hotelStatusUpdate = async (id, data) => {
    const response = await patch(`${process.env.EXTENDED_URL_WITHOUT_VERSION}org/${id}`, data);
    return hotelStatusUpdateApi(response);
};

export const hotelCreate = async (data, id, type) => {
    if (type == 'post') {
        const response = await post(`${process.env.EXTENDED_URL_WITHOUT_VERSION}org`, data);
        return hotelCreatePost(response);
    } else {
        const response_1 = await patch(`${process.env.EXTENDED_URL_WITHOUT_VERSION}org/${id}`, data);
        return hotelPatchApi(response_1);
    }
};

export const adminCreate = async (data, id, type) => {
    if (type == 'post') {
        const response = await post(`${process.env.EXTENDED_URL_WITHOUT_VERSION}users`, data);
        return adminCreatePost(response);
    } else {
        const response_1 = await patch(`${process.env.EXTENDED_URL_WITHOUT_VERSION}users/${id}`, data);
        return adminCreatePatch(response_1);
    }
};

export const hotelDelete = async (data) => {
    const response = await del(`${process.env.EXTENDED_URL_WITHOUT_VERSION}org`, data);
    return hotelsDeleteApi(response);
};

export const subscriptionListApi = async (data) => {
    const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}subscriptions_type`, data);
    return subscriptionListGet(response);
};

export const subscribApiCall = async (data) => {
    const response = await post(`${process.env.EXTENDED_URL_WITHOUT_VERSION}subscriptions_details`, data);
    return subscribApiCallFn(response);
};

export const versionListApi = async () => {
    const response = await get(`${process.env.EXTENDED_URL_WITHOUT_VERSION}version`, null);
    return versionListGet(response);
};

export const paymentCreate = async (data, id, type) => {
    version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? Store.default.getState().LoginReducer.userCredentials.user_details.version : "";
    if (type == 'post') {
        const response = await post(`${process.env.EXTENDED_URL}${version}/payment`, data);
        return paymentCreatePost(response);
    } else {
        const response_1 = await patch(`${process.env.EXTENDED_URL}${version}/payment/${id}`, data);
        return paymentCreatePatch(response_1);
    }
};
export const uploadScreenshot = async (data) => {
    version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? Store.default.getState().LoginReducer.userCredentials.user_details.version : "";
    const response = await post(`${process.env.EXTENDED_URL}${version}/payment/upload_screensort`, data);
    return uploadScreenshotPost(response);
};
export const getCreditPoint = async (data) => {
    version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? Store.default.getState().LoginReducer.userCredentials.user_details.version : "";
    const response = await get(`${process.env.EXTENDED_URL}${version}/payment/get_credit_points`, data);
    return creditPointGet(response);
};
export const paymentPriceDistribution = async (data, userType = 'admin') => {
    version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? Store.default.getState().LoginReducer.userCredentials.user_details.version : "";
    const response = await post(`${process.env.EXTENDED_URL}${version}/${['agent', 'agent_staff'].includes(userType.toLowerCase()) ? 'agency_branch/price_distribution' : 'bookings/price_distribution'}`, data);
    return paymentPriceDistributionGet(response);
};